import React, { useState, useEffect } from "react";
import "./CookieBanner.scss";

const CookiePreferencesModal = ({ onClose }) => {
    const [prefs, setPrefs] = useState({
        essential: true,
        analytics: false,
        functionality: false,
    });

    useEffect(() => {
        const saved = localStorage.getItem("cookie-preferences");
        if (saved) setPrefs(JSON.parse(saved));
    }, []);

    const toggle = (key) => {
        setPrefs((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const savePreferences = () => {
        localStorage.setItem("cookie-preferences", JSON.stringify(prefs));
        onClose();
    };

    return (
        <div className="cookie-modal-overlay">
            <div className="cookie-modal">
                <h2>Cookie Preferences</h2>
                <p>Adjust your cookie settings below:</p>

                <div className="cookie-option">
                    <label>
                        <input type="checkbox" checked disabled />
                        Essential Cookies (Always Active)
                    </label>
                </div>

                <div className="cookie-option">
                    <label>
                        <input
                            type="checkbox"
                            checked={prefs.analytics}
                            onChange={() => toggle("analytics")}
                        />
                        Analytics Cookies
                    </label>
                </div>

                <div className="cookie-option">
                    <label>
                        <input
                            type="checkbox"
                            checked={prefs.functionality}
                            onChange={() => toggle("functionality")}
                        />
                        Functionality Cookies
                    </label>
                </div>

                <div className="modal-actions">
                    <button className="close-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="save-btn" onClick={savePreferences}>
                        Save Preferences
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookiePreferencesModal;
